import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import {
  formatUsageNudgeAbsolute,
  formatUsageNudgeAge,
} from "../../../helpers/usage/usageNudgeHelpers";

interface UsageNudgedAgeLabelProps {
  sentAt: string;
  senderName?: string | null;
}

/**
 * Non-interactive replacement for the nudge button while a recipient is inside the
 * cooldown window. Shared by the assignments table and the accountability explorer so
 * both surfaces read the same.
 */
function UsageNudgedAgeLabel({ sentAt, senderName }: UsageNudgedAgeLabelProps) {
  const { t, i18n } = useTranslation();
  const absoluteDate = formatUsageNudgeAbsolute(sentAt, i18n.language);
  const title = senderName
    ? t("Analytics.Widgets.Usage.Nudge.SentTitleWithSender", {
        defaultValue: "Nudged on {{date}} by {{sender}}",
        date: absoluteDate,
        sender: senderName,
      })
    : t("Analytics.Widgets.Usage.Nudge.SentTitle", {
        defaultValue: "Nudged on {{date}}",
        date: absoluteDate,
      });

  return (
    <span
      className="inline-flex cursor-default items-center gap-1.5 whitespace-nowrap text-[13px] font-medium text-green-700"
      title={title}
    >
      <FontAwesomeIcon icon={faCheck} aria-hidden />
      {t("Analytics.Widgets.Usage.Nudge.NudgedAge", {
        defaultValue: "Nudged {{age}}",
        age: formatUsageNudgeAge(sentAt),
      })}
    </span>
  );
}

export default UsageNudgedAgeLabel;
